var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fe90ca1b-871e-469d-9cfe-f6df4d5c24db",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139.56 139.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M89.49,34.35v70.9h-50V34.35h0a6.58,6.58,0,0,0,3.33.9A6.4,6.4,0,0,0,44.63,35a6.68,6.68,0,0,0,6.52,5.29,6.4,6.4,0,0,0,.88-.09,6.6,6.6,0,0,0,10.79,1.12,6.62,6.62,0,0,0,5,2.3l.23,0a6.6,6.6,0,0,0,1.27,2.52,6.67,6.67,0,1,0,10.33,0,6.58,6.58,0,0,0,1.5-4.17,6.81,6.81,0,0,0-.44-2.35A6.66,6.66,0,0,0,84.34,35a6.4,6.4,0,0,0,1.81.29,6.62,6.62,0,0,0,3.34-.9Z",
    style: {
      fill: "#f7c201"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.49,115.25h-50a5,5,0,0,1,0-10h50a5,5,0,1,1,0,10Z",
    style: {
      fill: "#e2dee2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.49,83.58h8.33a3.33,3.33,0,0,0,3.33-3.33V51.91a3.33,3.33,0,0,0-3.33-3.33H89.49V41.91h8.33a10,10,0,0,1,10,10V80.25a10,10,0,0,1-10,10H89.49Z",
    style: {
      fill: "#e2dee2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.33,22a6.58,6.58,0,0,0-3.73-1.71,6.64,6.64,0,0,0-5.78-3.41,6.57,6.57,0,0,0-3.17.84,6.6,6.6,0,0,0-5.16-2.5,6.66,6.66,0,0,0-3.34.92,6.52,6.52,0,0,0-7.5.58,6.56,6.56,0,0,0-4.16-1.5,6.63,6.63,0,0,0-5.79,3.42,6.4,6.4,0,0,0-.88-.09A6.65,6.65,0,0,0,42,22a6.65,6.65,0,0,0,.79,13.26A6.4,6.4,0,0,0,44.63,35a6.68,6.68,0,0,0,6.52,5.29,6.4,6.4,0,0,0,.88-.09,6.6,6.6,0,0,0,10.79,1.12,6.62,6.62,0,0,0,5,2.3l.23,0a6.6,6.6,0,0,0,1.27,2.52,6.67,6.67,0,1,0,10.33,0,6.58,6.58,0,0,0,1.5-4.17,6.81,6.81,0,0,0-.44-2.35A6.66,6.66,0,0,0,84.34,35a6.4,6.4,0,0,0,1.81.29A6.66,6.66,0,0,0,87.33,22Z",
    style: {
      fill: "#f3f0f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.49,98.58a3.33,3.33,0,0,1-3.34-3.33v-30a3.34,3.34,0,1,1,6.67,0v30A3.33,3.33,0,0,1,49.49,98.58Z",
    style: {
      fill: "#fcdd2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.49,98.58a3.33,3.33,0,0,1-3.34-3.33v-30a3.34,3.34,0,1,1,6.67,0v30A3.33,3.33,0,0,1,64.49,98.58Z",
    style: {
      fill: "#fcdd2e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.49,98.58a3.33,3.33,0,0,1-3.34-3.33v-30a3.34,3.34,0,1,1,6.67,0v30A3.33,3.33,0,0,1,79.49,98.58Z",
    style: {
      fill: "#fcdd2e"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeerIcon);
export default __webpack_public_path__ + "static/media/beer-icon.9c16c543881c471286a8bc39739e06c5.svg";
export { ForwardRef as ReactComponent };